import React from "react";

export const DriverTransferRequestDetailContext = React.createContext(null);

export const useDriverTransferRequestDetailContext = () => {
  const context = React.useContext(DriverTransferRequestDetailContext);

  if (!context)
    throw new Error("Driver Transfer Request Detail Context not provided!");

  return context;
};
